module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot21.a6ac504d.jpg";